import React from 'react';
import './ScoreTypeChip.scss';

function ScoreTypeChip({
    children,
    onClick,
}: {
    children: React.ReactNode;
    onClick: () => void;
}): React.ReactElement {
    return (
        <button type="button" onClick={onClick} className="score-type-chip">
            {children}{' '}
        </button>
    );
}

export default React.memo(ScoreTypeChip);
